<template>
  <div style="height: 100%">
    <Calendar />
  </div>
</template>

<script>
import Calendar from '../../components/tasks/NewCalendar/Calendar.vue'
export default {
  components: {
    Calendar
  }
}
</script>
